export default __webpack_public_path__ + "static/media/rz_dg-degruyter.5de94ce4.jpg";